import Modal from 'bootstrap/js/dist/modal'

/**
 * Auto Showing Modal Bootstrap Component
 *
 * Automatically shows Bootstrap modals on page load when data-auto-show is present on the modal element.
 *
 * @example
 * ```html
 * <div class="modal" id="a-modal" data-auto-show>
 *   <!-- modal content -->
 * </div>
 * ```
 */
export function initAutoShowingModals(): void {
  document
    .querySelectorAll('div.modal[data-auto-show]')
    .forEach((modalElement) => {
      const modal = createModal(modalElement as HTMLElement)
      if (modal) {
        modal.show()
        document.addEventListener('hide.bs.modal', () => {
          ;(document.activeElement as HTMLElement).blur()
        })
      }
    })
}

function createModal(modalElement: HTMLElement): Modal | null {
  try {
    return new Modal(modalElement)
  } catch (error) {
    console.error(`Error creating modal ${modalElement.id}:`, error)
    return null
  }
}
